import React from 'react';
import { usePermission } from '@hooks/usePermission';
import { Outlet } from 'react-router';
import { RedirectHomeAccessDenied } from '@routes/RedirectHomeAccessDenied';

export const RequirePermission = ({
  permission,
  permissions,
}: IRequirePermission) => {
  const { can } = usePermission();
  const requiredPermissions = permissions ?? (permission ? [permission] : []);

  if (!requiredPermissions.some((requiredPermission) => can(requiredPermission))) {
    return <RedirectHomeAccessDenied />;
  }

  return <Outlet />;
};
